import Article1 from "../images/article1.jpg";
import Article2 from "../images/article2.jpg";
import Article3 from "../images/article3.jpg";
import Article4 from "../images/article4.jpg";
import Article5 from "../images/article5.jpg";
import Article6 from "../images/article6.jpg";
import Article7 from "../images/article7.jpg";
import Article8 from "../images/article8.jpg";
import Article9 from "../images/article9.jpg";

export const articledata = {
    "0" : {
        article_source: Article1,
        article_title: "Preprofessional Problems",
        article_link: "https://archive-publications.library.columbia.edu/?a=d&d=cs19651118-01.2.10&e=-------en-20-cs-1--txt-txIN-preprofessionalism------",
        article_date: "November 18, 1965"
    },
    "1" : {
        article_source: Article2,
        article_title: "Fear for the liberal arts",
        article_link: "https://archive-publications.library.columbia.edu/?a=d&d=cs19831011-01.2.17&srpos=4&e=-------en-20-cs-1--txt-txIN-preprofessionalism------",
        article_date: "October 11, 1983"
    },
    "2" : {
        article_source: Article3,
        article_title: "Education for avocation creation",
        article_link: "https://archive-publications.library.columbia.edu/?a=d&d=cs19880909-01.2.11&srpos=15&e=-------en-20-cs-1--txt-txIN-careerism------",
        article_date: "September 9, 1988"
    },
    "3" : {
        article_source: Article4,
        article_title: "Choosing careerism",
        article_link: "https://archive-publications.library.columbia.edu/?a=d&d=cs19880916-01.2.18&srpos=1&e=-------en-20-cs-1--txt-txIN-careerism------",
        article_date: "September 16, 1988"
    },
    "4" : {
        article_source: Article5,
        article_title: "Backpacks and Briefcases",
        article_link: "https://archive-publications.library.columbia.edu/?a=d&d=cs20101004-01.2.25&e=-------en-20--1--txt-txIN-pre%252Dprofessionalism------",
        article_date: "October 4, 2010"
    },
    "5" : {
        article_source: Article6,
        article_title: "Offer credit for internships",
        article_link: "https://archive-publications.library.columbia.edu/?a=d&d=cs20101018-01.2.17&srpos=11&e=-------en-20--1--txt-txIN-pre%252Dprofessionalism------",
        article_date: "October 18, 2010"
    },
    "6" : {
        article_source: Article7,
        article_title: "Timeless humanities",
        article_link: "https://archive-publications.library.columbia.edu/?a=d&d=cs20110323-01.2.13&srpos=22&e=-------en-20--21--txt-txIN-pre%252Dprofessionalism------",
        article_date: "March 23, 2011"
    },
    "7" : {
        article_source: Article8,
        article_title: "What I would like to tell an interviewer",
        article_link: "https://archive-publications.library.columbia.edu/?a=d&d=cs20110912-01.2.15&srpos=18&e=-------en-20--1--txt-txIN-pre%252Dprofessionalism------",
        article_date: "September 12, 2011"
    },
    "8" : {
        article_source: Article9,
        article_title: "A specialized liberal education",
        article_link: "https://archive-publications.library.columbia.edu/?a=d&d=cs20121025-01.2.20",
        article_date: "October 25, 2012"
    },
    "9" : {
        article_source: "https://www.columbiaspectator.com/resizer/v2/4W5L37FKWBCZLILJZ355YOPNVE.png?auth=40423f94c25ce38d454b95a8906cb69e5a9af8c4c343c639baf81a854b4612b6",
        article_title: "Columbia is Wall Street’s campus",
        article_link: "https://www.columbiaspectator.com/opinion/2025/03/24/columbia-is-wall-streets-campus/",
        article_date: "March 24, 2025"
    }
    
}